import { IconHelp } from "@tabler/icons";

const icons = {
  IconHelp,
};

const guide = {
  id: "help",
  title: "ความช่วยเหลือ",
  type: "group",
  children: [
    {
      id: "user-guide",
      title: "แนะนำการใช้งาน",
      type: "item",
      url: "/guide",
      icon: icons.IconHelp,
      breadcrumbs: true,
    },
  ],
};

export default guide;
